const colors = {
    white: "#FFFFFF",
    white10: "rgba(255, 255, 255, 0.1)",
    white20: "rgba(255, 255, 255, 0.2)",
    white40: "rgba(255, 255, 255, 0.4)",
    white400: "rgba(255, 255, 255, 0.04)",
    white50: "rgba(255, 255, 255, 0.5)",
    white500: "rgba(255, 255, 255, 0.05)",
    white600: "rgba(255, 255, 255, 0.06)",
    white60: "rgba(255, 255, 255, 0.6)",
    white70: "rgba(255, 255, 255, 0.7)",
    white80: "rgba(255, 255, 255, 0.8)",
    japaaBlack: "#0C0E26",
    grey01: "#E0E0E0;",
    japaaGreen: "#37FED9",
    japaaGreen80: "rgba(55, 254, 217, 0.8)",
    japaaGreen40: "rgba(55, 254, 217, 0.4)",
    chatBox: "#E5E6ED",
    redError: "#EB5757",
};

export { colors };